document.addEventListener('DOMContentLoaded', function () {
    const mustConfirms = document.querySelectorAll('.must-confirm');

    mustConfirms.forEach(mustConfirm => {
        mustConfirm.addEventListener('click', function (e) {
            if (!confirm('Are you sure?')) {
                e.preventDefault();
            }
        });
    });
});